import { DSMEnvironments } from '../components/pages/LoginPage/types'

const getSSOBaseUrl = (): string => {
  const host = window.location.hostname
  const fallback = process.env.REACT_APP_BASE_URL_SSO || window.location.origin

  switch (host) {
    case DSMEnvironments.DEV:
    case DSMEnvironments.DEV_REMOTE:
      return process.env.REACT_APP_BASE_URL_SSO_DEV || fallback
    case DSMEnvironments.STAGING:
      return (
        process.env.REACT_APP_BASE_URL_SSO_STAGING ||
        process.env.REACT_APP_BASE_URL_SSO_DEV ||
        fallback
      )
    case DSMEnvironments.PROD:
      return process.env.REACT_APP_BASE_URL_SSO_PROD || fallback
    case DSMEnvironments.DEMO:
      return process.env.REACT_APP_BASE_URL_SSO_DEMO || fallback
    default:
      return process.env.REACT_APP_BASE_URL_SSO_PROD || fallback
  }
}

export default getSSOBaseUrl
